module.exports = __webpack_public_path__ + "static/img/logo6.1f6a861d.jpg";